import { useTranslation } from "react-i18next";

import MessageThreadIcon from "src/core/assets/images/icons/messageThread.svg?react";
import { FolderMessageThreadModal } from "src/core/components/folder/FolderMessageThreadModal";
import { Button } from "src/core/components/ui/button";
import { useFolderMessageThread } from "src/core/hooks/folder/useFolderMessageThread";

export const FolderMessageThread = () => {
  const { t } = useTranslation();
  const { displayMessageThread, messageThreadOpen, setMessageThreadOpen } =
    useFolderMessageThread();

  return (
    <>
      {displayMessageThread && (
        <>
          <div className="w-20 h-[calc(100vh-170px)] absolute top-0 right-0 bg-border-secondary rounded-l-lg z-50">
            &nbsp;
          </div>
          <div className="flex justify-center pr-20 absolute top-20 right-0 z-50">
            <Button variant="sideTabMuted" size="none" onClick={() => setMessageThreadOpen(true)}>
              <div className="flex items-center justify-center w-30 h-30 rounded-full bg-muted group-hover:text-foreground text-white">
                <MessageThreadIcon />
              </div>
              <span className="text-muted-foreground group-hover:text-foreground group-hover:underline">
                {t("messageThread.button.open")}
              </span>
            </Button>
          </div>
        </>
      )}

      <FolderMessageThreadModal open={messageThreadOpen} setOpen={setMessageThreadOpen} />
    </>
  );
};
